module.exports = __webpack_public_path__ + "img/triangles_circles.613506fb.svg";